export default __webpack_public_path__ + "static/media/background.86f1f01e.svg";